/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './content-message-edit.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/common/src/pipes/date_pipe';
import * as import5 from '@angular/core/src/linker/view_utils';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/change_detection';
import * as import9 from '@angular/core/src/i18n/tokens';
import * as import10 from '../shared/config.service';
import * as import11 from '../shared/intl.service';
import * as import12 from '../shared/meta.service';
import * as import13 from '@angular/core/src/linker/element_ref';
import * as import14 from '../shared/search.service';
import * as import15 from '../shared/utils.service';
import * as import16 from '@angular/forms/src/form_builder';
import * as import17 from '@angular/router/src/router';
import * as import18 from '../shared/content.service';
import * as import19 from '@angular/router/src/router_state';
import * as import20 from '@angular/core/src/metadata/view';
import * as import21 from '@angular/core/src/linker/component_factory';
import * as import22 from '../../../node_modules/@angular/common/src/directives/ng_switch.ngfactory';
import * as import23 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import24 from '@angular/common/src/pipes/uppercase_pipe';
import * as import25 from '@angular/core/src/linker/template_ref';
import * as import26 from '@angular/common/src/directives/ng_switch';
import * as import27 from '@angular/common/src/directives/ng_if';
import * as import28 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_group_directive.ngfactory';
import * as import29 from '../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import30 from '../../../node_modules/@angular/forms/src/directives/checkbox_value_accessor.ngfactory';
import * as import31 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_control_name.ngfactory';
import * as import32 from '../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import33 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_group_name.ngfactory';
import * as import34 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import35 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import36 from '@angular/forms/src/directives/checkbox_value_accessor';
import * as import37 from '@angular/forms/src/directives/control_value_accessor';
import * as import38 from '@angular/forms/src/directives/reactive_directives/form_control_name';
import * as import39 from '@angular/forms/src/directives/ng_control';
import * as import40 from '@angular/forms/src/directives/ng_control_status';
import * as import41 from '@angular/forms/src/directives/default_value_accessor';
import * as import42 from '@angular/common/src/directives/ng_for';
import * as import43 from '@angular/forms/src/directives/reactive_directives/form_group_name';
import * as import44 from '@angular/forms/src/directives/control_container';
import * as import45 from '@angular/forms/src/directives/reactive_directives/form_group_directive';
import * as import46 from './html-editor.component.ngfactory';
import * as import47 from './html-editor.component';
export class Wrapper_ContentMessageEditComponent {
  context:import0.ContentMessageEditComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any,p10:any) {
    this.changed = false;
    this.context = new import0.ContentMessageEditComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9,p10);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ContentMessageEditComponent_Host:import2.RenderComponentType = (null as any);
class _View_ContentMessageEditComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _DatePipe_0_4:import4.DatePipe;
  _ContentMessageEditComponent_0_5:Wrapper_ContentMessageEditComponent;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentMessageEditComponent_Host0,renderType_ContentMessageEditComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.selectOrCreateRenderHostElement(this.renderer,'ng-component',import5.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ContentMessageEditComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._DatePipe_0_4 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
    this._ContentMessageEditComponent_0_5 = new Wrapper_ContentMessageEditComponent(this.parentInjector.get(import10.ConfigService),this.parentInjector.get(import11.IntlService),this.parentInjector.get(import12.MetaService),new import13.ElementRef(this._el_0),this.parentInjector.get(import14.SearchService),this._DatePipe_0_4,this.parentInjector.get(import15.UtilsService),this.parentInjector.get(import16.FormBuilder),this.parentInjector.get(import17.Router),this.parentInjector.get(import18.ContentService),this.parentInjector.get(import19.ActivatedRoute));
    this._appEl_0.initComponent(this._ContentMessageEditComponent_0_5.context,([] as any[]),compView_0);
    compView_0.create(this._ContentMessageEditComponent_0_5.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import4.DatePipe) && (0 === requestNodeIndex))) { return this._DatePipe_0_4; }
    if (((token === import0.ContentMessageEditComponent) && (0 === requestNodeIndex))) { return this._ContentMessageEditComponent_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentMessageEditComponent_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._ContentMessageEditComponent_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentMessageEditComponent_Host0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_ContentMessageEditComponent_Host === (null as any))) { (renderType_ContentMessageEditComponent_Host = viewUtils.createRenderComponentType('',0,import20.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ContentMessageEditComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ContentMessageEditComponentNgFactory:import21.ComponentFactory<import0.ContentMessageEditComponent> = new import21.ComponentFactory<import0.ContentMessageEditComponent>('ng-component',viewFactory_ContentMessageEditComponent_Host0,import0.ContentMessageEditComponent);
const styles_ContentMessageEditComponent:any[] = ([] as any[]);
var renderType_ContentMessageEditComponent:import2.RenderComponentType = (null as any);
class _View_ContentMessageEditComponent0 extends import1.AppView<import0.ContentMessageEditComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgSwitch_2_3:import22.Wrapper_NgSwitch;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _appEl_5:import3.AppElement;
  _TemplateRef_5_5:any;
  _NgSwitchCase_5_6:import22.Wrapper_NgSwitchCase;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _appEl_7:import3.AppElement;
  _TemplateRef_7_5:any;
  _NgSwitchCase_7_6:import22.Wrapper_NgSwitchCase;
  _text_8:any;
  _anchor_9:any;
  /*private*/ _appEl_9:import3.AppElement;
  _TemplateRef_9_5:any;
  _NgSwitchCase_9_6:import22.Wrapper_NgSwitchCase;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _anchor_23:any;
  /*private*/ _appEl_23:import3.AppElement;
  _TemplateRef_23_5:any;
  _NgIf_23_6:import23.Wrapper_NgIf;
  _text_24:any;
  _text_25:any;
  _text_26:any;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _pipe_date_0:import4.DatePipe;
  _pipe_uppercase_1:import24.UpperCasePipe;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentMessageEditComponent0,renderType_ContentMessageEditComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import5.createRenderElement(this.renderer,parentRenderNode,'section',new import5.InlineArray2(2,'class','content-header'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n  ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'h1',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSwitch_2_3 = new import22.Wrapper_NgSwitch();
    this._text_3 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_4 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._appEl_5 = new import3.AppElement(5,2,this,this._anchor_5);
    this._TemplateRef_5_5 = new import25.TemplateRef_(this._appEl_5,viewFactory_ContentMessageEditComponent1);
    this._NgSwitchCase_5_6 = new import22.Wrapper_NgSwitchCase(this._appEl_5.vcRef,this._TemplateRef_5_5,this._NgSwitch_2_3.context);
    this._text_6 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._appEl_7 = new import3.AppElement(7,2,this,this._anchor_7);
    this._TemplateRef_7_5 = new import25.TemplateRef_(this._appEl_7,viewFactory_ContentMessageEditComponent2);
    this._NgSwitchCase_7_6 = new import22.Wrapper_NgSwitchCase(this._appEl_7.vcRef,this._TemplateRef_7_5,this._NgSwitch_2_3.context);
    this._text_8 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._anchor_9 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._appEl_9 = new import3.AppElement(9,2,this,this._anchor_9);
    this._TemplateRef_9_5 = new import25.TemplateRef_(this._appEl_9,viewFactory_ContentMessageEditComponent3);
    this._NgSwitchCase_9_6 = new import22.Wrapper_NgSwitchCase(this._appEl_9.vcRef,this._TemplateRef_9_5,this._NgSwitch_2_3.context);
    this._text_10 = this.renderer.createText(this._el_2,'\n  ',(null as any));
    this._text_11 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_12 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_13 = import5.createRenderElement(this.renderer,parentRenderNode,'section',new import5.InlineArray2(2,'class','content'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n  ',(null as any));
    this._el_15 = import5.createRenderElement(this.renderer,this._el_13,'div',new import5.InlineArray2(2,'class','row'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n    ',(null as any));
    this._el_17 = import5.createRenderElement(this.renderer,this._el_15,'div',new import5.InlineArray2(2,'class','col-xs-12'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n      ',(null as any));
    this._el_19 = import5.createRenderElement(this.renderer,this._el_17,'div',new import5.InlineArray2(2,'class','box'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'\n        ',(null as any));
    this._el_21 = import5.createRenderElement(this.renderer,this._el_19,'div',new import5.InlineArray2(2,'class','box-body'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n\n          ',(null as any));
    this._anchor_23 = this.renderer.createTemplateAnchor(this._el_21,(null as any));
    this._appEl_23 = new import3.AppElement(23,21,this,this._anchor_23);
    this._TemplateRef_23_5 = new import25.TemplateRef_(this._appEl_23,viewFactory_ContentMessageEditComponent4);
    this._NgIf_23_6 = new import23.Wrapper_NgIf(this._appEl_23.vcRef,this._TemplateRef_23_5);
    this._text_24 = this.renderer.createText(this._el_21,'\n\n\n        ',(null as any));
    this._text_25 = this.renderer.createText(this._el_19,'\n        ',(null as any));
    this._text_26 = this.renderer.createText(this._el_19,'\n      ',(null as any));
    this._text_27 = this.renderer.createText(this._el_17,'\n    ',(null as any));
    this._text_28 = this.renderer.createText(this._el_15,'\n  ',(null as any));
    this._text_29 = this.renderer.createText(this._el_13,'\n',(null as any));
    this._pipe_date_0 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
    this._pipe_uppercase_1 = new import24.UpperCasePipe();
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._anchor_7,
      this._text_8,
      this._anchor_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._anchor_23,
      this._text_24,
      this._text_25,
      this._text_26,
      this._text_27,
      this._text_28,
      this._text_29
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import26.NgSwitchCase) && (5 === requestNodeIndex))) { return this._NgSwitchCase_5_6.context; }
    if (((token === import25.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import26.NgSwitchCase) && (7 === requestNodeIndex))) { return this._NgSwitchCase_7_6.context; }
    if (((token === import25.TemplateRef) && (9 === requestNodeIndex))) { return this._TemplateRef_9_5; }
    if (((token === import26.NgSwitchCase) && (9 === requestNodeIndex))) { return this._NgSwitchCase_9_6.context; }
    if (((token === import26.NgSwitch) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._NgSwitch_2_3.context; }
    if (((token === import25.TemplateRef) && (23 === requestNodeIndex))) { return this._TemplateRef_23_5; }
    if (((token === import27.NgIf) && (23 === requestNodeIndex))) { return this._NgIf_23_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.context.action;
    this._NgSwitch_2_3.check_ngSwitch(currVal_2_0_0,throwOnChange,false);
    this._NgSwitch_2_3.detectChangesInInputProps(this,this._el_2,throwOnChange);
    const currVal_5_0_0:any = 'add';
    this._NgSwitchCase_5_6.check_ngSwitchCase(currVal_5_0_0,throwOnChange,false);
    this._NgSwitchCase_5_6.detectChangesInInputProps(this,this._anchor_5,throwOnChange);
    const currVal_7_0_0:any = 'update';
    this._NgSwitchCase_7_6.check_ngSwitchCase(currVal_7_0_0,throwOnChange,false);
    this._NgSwitchCase_7_6.detectChangesInInputProps(this,this._anchor_7,throwOnChange);
    const currVal_9_0_0:any = 'update';
    this._NgSwitchCase_9_6.check_ngSwitchCase(currVal_9_0_0,throwOnChange,false);
    this._NgSwitchCase_9_6.detectChangesInInputProps(this,this._anchor_9,throwOnChange);
    const currVal_23_0_0:any = (this.context.content || (this.context.action == 'add'));
    this._NgIf_23_6.check_ngIf(currVal_23_0_0,throwOnChange,false);
    this._NgIf_23_6.detectChangesInInputProps(this,this._anchor_23,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgSwitch_2_3.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_ContentMessageEditComponent0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<import0.ContentMessageEditComponent> {
  if ((renderType_ContentMessageEditComponent === (null as any))) { (renderType_ContentMessageEditComponent = viewUtils.createRenderComponentType('',0,import20.ViewEncapsulation.None,styles_ContentMessageEditComponent,{})); }
  return new _View_ContentMessageEditComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ContentMessageEditComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentMessageEditComponent1,renderType_ContentMessageEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'Nouveau contenu',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
}
function viewFactory_ContentMessageEditComponent1(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentMessageEditComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_ContentMessageEditComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentMessageEditComponent2,renderType_ContentMessageEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'Edition',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
}
function viewFactory_ContentMessageEditComponent2(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentMessageEditComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_ContentMessageEditComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  _pipe_date_0_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentMessageEditComponent3,renderType_ContentMessageEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_4 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,' ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'small',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._pipe_date_0_0 = import5.pureProxy2((<_View_ContentMessageEditComponent0>this.parent)._pipe_date_0.transform.bind((<_View_ContentMessageEditComponent0>this.parent)._pipe_date_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import5.interpolate(1,'(modifié: ',valUnwrapper.unwrap(import5.castByValue(this._pipe_date_0_0,(<_View_ContentMessageEditComponent0>this.parent)._pipe_date_0.transform)(((this.parent.context.content == (null as any))? (null as any): this.parent.context.content.update_date),'dd MM yyyy')),')');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_3,currVal_4);
      this._expr_4 = currVal_4;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentMessageEditComponent3(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentMessageEditComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_ContentMessageEditComponent4 extends import1.AppView<any> {
  _el_0:any;
  _FormGroupDirective_0_3:import28.Wrapper_FormGroupDirective;
  _ControlContainer_0_4:any;
  _NgControlStatusGroup_0_5:import29.Wrapper_NgControlStatusGroup;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _CheckboxControlValueAccessor_13_3:import30.Wrapper_CheckboxControlValueAccessor;
  _NG_VALUE_ACCESSOR_13_4:any[];
  _FormControlName_13_5:import31.Wrapper_FormControlName;
  _NgControl_13_6:any;
  _NgControlStatus_13_7:import29.Wrapper_NgControlStatus;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _DefaultValueAccessor_20_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_20_4:any[];
  _FormControlName_20_5:import31.Wrapper_FormControlName;
  _NgControl_20_6:any;
  _NgControlStatus_20_7:import29.Wrapper_NgControlStatus;
  _text_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _el_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _DefaultValueAccessor_28_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_28_4:any[];
  _FormControlName_28_5:import31.Wrapper_FormControlName;
  _NgControl_28_6:any;
  _NgControlStatus_28_7:import29.Wrapper_NgControlStatus;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  _text_32:any;
  _el_33:any;
  _text_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _el_38:any;
  _FormGroupName_38_3:import33.Wrapper_FormGroupName;
  _ControlContainer_38_4:any;
  _NgControlStatusGroup_38_5:import29.Wrapper_NgControlStatusGroup;
  _text_39:any;
  _anchor_40:any;
  /*private*/ _appEl_40:import3.AppElement;
  _TemplateRef_40_5:any;
  _NgFor_40_6:import34.Wrapper_NgFor;
  _text_41:any;
  _text_42:any;
  _text_43:any;
  _el_44:any;
  _text_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _el_49:any;
  _FormGroupName_49_3:import33.Wrapper_FormGroupName;
  _ControlContainer_49_4:any;
  _NgControlStatusGroup_49_5:import29.Wrapper_NgControlStatusGroup;
  _text_50:any;
  _anchor_51:any;
  /*private*/ _appEl_51:import3.AppElement;
  _TemplateRef_51_5:any;
  _NgFor_51_6:import34.Wrapper_NgFor;
  _text_52:any;
  _text_53:any;
  _text_54:any;
  _el_55:any;
  _text_56:any;
  _text_57:any;
  _el_58:any;
  _text_59:any;
  _el_60:any;
  _FormGroupName_60_3:import33.Wrapper_FormGroupName;
  _ControlContainer_60_4:any;
  _NgControlStatusGroup_60_5:import29.Wrapper_NgControlStatusGroup;
  _text_61:any;
  _anchor_62:any;
  /*private*/ _appEl_62:import3.AppElement;
  _TemplateRef_62_5:any;
  _NgFor_62_6:import34.Wrapper_NgFor;
  _text_63:any;
  _text_64:any;
  _text_65:any;
  _el_66:any;
  _text_67:any;
  _text_68:any;
  _text_69:any;
  /*private*/ _expr_106:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentMessageEditComponent4,renderType_ContentMessageEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_106 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'form',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._FormGroupDirective_0_3 = new import28.Wrapper_FormGroupDirective((null as any),(null as any));
    this._ControlContainer_0_4 = this._FormGroupDirective_0_3.context;
    this._NgControlStatusGroup_0_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
    this._text_1 = this.renderer.createText(this._el_0,'\n\n            ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','panel panel-default'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'Métadonnées',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_7 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n                ',(null as any));
    this._el_9 = import5.createRenderElement(this.renderer,this._el_7,'div',new import5.InlineArray2(2,'class','form-inline'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n                  ',(null as any));
    this._el_11 = import5.createRenderElement(this.renderer,this._el_9,'div',new import5.InlineArray2(2,'class','col-md-1 col-sm-1 input-group switch material-switch'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n                    ',(null as any));
    this._el_13 = import5.createRenderElement(this.renderer,this._el_11,'input',new import5.InlineArray8(8,'formControlName','active','id','act','name','act','type','checkbox'),(null as any));
    this._CheckboxControlValueAccessor_13_3 = new import30.Wrapper_CheckboxControlValueAccessor(this.renderer,new import13.ElementRef(this._el_13));
    this._NG_VALUE_ACCESSOR_13_4 = [this._CheckboxControlValueAccessor_13_3.context];
    this._FormControlName_13_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_13_4);
    this._NgControl_13_6 = this._FormControlName_13_5.context;
    this._NgControlStatus_13_7 = new import29.Wrapper_NgControlStatus(this._NgControl_13_6);
    this._text_14 = this.renderer.createText(this._el_11,'\n                    ',(null as any));
    this._el_15 = import5.createRenderElement(this.renderer,this._el_11,'label',new import5.InlineArray4(4,'class','label-primary','for','act'),(null as any));
    this._text_16 = this.renderer.createText(this._el_11,'\n                  ',(null as any));
    this._text_17 = this.renderer.createText(this._el_9,'\n                  ',(null as any));
    this._el_18 = import5.createRenderElement(this.renderer,this._el_9,'div',new import5.InlineArray2(2,'class','input-group col-md-4 col-sm-5'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n                    ',(null as any));
    this._el_20 = import5.createRenderElement(this.renderer,this._el_18,'input',new import5.InlineArray8(6,'class','form-control','formControlName','label','type','text'),(null as any));
    this._DefaultValueAccessor_20_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_20));
    this._NG_VALUE_ACCESSOR_20_4 = [this._DefaultValueAccessor_20_3.context];
    this._FormControlName_20_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_20_4);
    this._NgControl_20_6 = this._FormControlName_20_5.context;
    this._NgControlStatus_20_7 = new import29.Wrapper_NgControlStatus(this._NgControl_20_6);
    this._text_21 = this.renderer.createText(this._el_18,'\n                  ',(null as any));
    this._text_22 = this.renderer.createText(this._el_9,'\n                  ',(null as any));
    this._el_23 = import5.createRenderElement(this.renderer,this._el_9,'div',new import5.InlineArray2(2,'class','input-group col-md-6 col-sm-5'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'\n                      ',(null as any));
    this._el_25 = import5.createRenderElement(this.renderer,this._el_23,'div',new import5.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_26 = import5.createRenderElement(this.renderer,this._el_25,'i',new import5.InlineArray2(2,'class','fa fa-external-link'),(null as any));
    this._text_27 = this.renderer.createText(this._el_23,'\n                      ',(null as any));
    this._el_28 = import5.createRenderElement(this.renderer,this._el_23,'input',new import5.InlineArray8(6,'class','form-control','formControlName','url','type','text'),(null as any));
    this._DefaultValueAccessor_28_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_28));
    this._NG_VALUE_ACCESSOR_28_4 = [this._DefaultValueAccessor_28_3.context];
    this._FormControlName_28_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_28_4);
    this._NgControl_28_6 = this._FormControlName_28_5.context;
    this._NgControlStatus_28_7 = new import29.Wrapper_NgControlStatus(this._NgControl_28_6);
    this._text_29 = this.renderer.createText(this._el_23,'\n                  ',(null as any));
    this._text_30 = this.renderer.createText(this._el_9,'\n                ',(null as any));
    this._text_31 = this.renderer.createText(this._el_7,'\n              ',(null as any));
    this._text_32 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_33 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_34 = this.renderer.createText(this._el_33,'Titre',(null as any));
    this._text_35 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_36 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'\n                ',(null as any));
    this._el_38 = import5.createRenderElement(this.renderer,this._el_36,'div',new import5.InlineArray4(4,'class','form-inline','formGroupName','title'),(null as any));
    this._FormGroupName_38_3 = new import33.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_38_4 = this._FormGroupName_38_3.context;
    this._NgControlStatusGroup_38_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_38_4);
    this._text_39 = this.renderer.createText(this._el_38,'\n                  ',(null as any));
    this._anchor_40 = this.renderer.createTemplateAnchor(this._el_38,(null as any));
    this._appEl_40 = new import3.AppElement(40,38,this,this._anchor_40);
    this._TemplateRef_40_5 = new import25.TemplateRef_(this._appEl_40,viewFactory_ContentMessageEditComponent5);
    this._NgFor_40_6 = new import34.Wrapper_NgFor(this._appEl_40.vcRef,this._TemplateRef_40_5,this.parent.parentInjector.get(import35.IterableDiffers),this.parent.ref);
    this._text_41 = this.renderer.createText(this._el_38,'\n                ',(null as any));
    this._text_42 = this.renderer.createText(this._el_36,'\n              ',(null as any));
    this._text_43 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_44 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_45 = this.renderer.createText(this._el_44,'Sous-titre',(null as any));
    this._text_46 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_47 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'\n                ',(null as any));
    this._el_49 = import5.createRenderElement(this.renderer,this._el_47,'div',new import5.InlineArray4(4,'class','form-inline','formGroupName','subtitle'),(null as any));
    this._FormGroupName_49_3 = new import33.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_49_4 = this._FormGroupName_49_3.context;
    this._NgControlStatusGroup_49_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_49_4);
    this._text_50 = this.renderer.createText(this._el_49,'\n                  ',(null as any));
    this._anchor_51 = this.renderer.createTemplateAnchor(this._el_49,(null as any));
    this._appEl_51 = new import3.AppElement(51,49,this,this._anchor_51);
    this._TemplateRef_51_5 = new import25.TemplateRef_(this._appEl_51,viewFactory_ContentMessageEditComponent6);
    this._NgFor_51_6 = new import34.Wrapper_NgFor(this._appEl_51.vcRef,this._TemplateRef_51_5,this.parent.parentInjector.get(import35.IterableDiffers),this.parent.ref);
    this._text_52 = this.renderer.createText(this._el_49,'\n                ',(null as any));
    this._text_53 = this.renderer.createText(this._el_47,'\n              ',(null as any));
    this._text_54 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_55 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_56 = this.renderer.createText(this._el_55,'Contenu',(null as any));
    this._text_57 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_58 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_59 = this.renderer.createText(this._el_58,'\n                ',(null as any));
    this._el_60 = import5.createRenderElement(this.renderer,this._el_58,'div',new import5.InlineArray2(2,'formGroupName','content'),(null as any));
    this._FormGroupName_60_3 = new import33.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_60_4 = this._FormGroupName_60_3.context;
    this._NgControlStatusGroup_60_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_60_4);
    this._text_61 = this.renderer.createText(this._el_60,'\n                  ',(null as any));
    this._anchor_62 = this.renderer.createTemplateAnchor(this._el_60,(null as any));
    this._appEl_62 = new import3.AppElement(62,60,this,this._anchor_62);
    this._TemplateRef_62_5 = new import25.TemplateRef_(this._appEl_62,viewFactory_ContentMessageEditComponent7);
    this._NgFor_62_6 = new import34.Wrapper_NgFor(this._appEl_62.vcRef,this._TemplateRef_62_5,this.parent.parentInjector.get(import35.IterableDiffers),this.parent.ref);
    this._text_63 = this.renderer.createText(this._el_60,'\n                ',(null as any));
    this._text_64 = this.renderer.createText(this._el_58,'\n              ',(null as any));
    this._text_65 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_66 = import5.createRenderElement(this.renderer,this._el_2,'button',new import5.InlineArray4(4,'class','btn btn-info pull-right','type','submit'),(null as any));
    this._text_67 = this.renderer.createText(this._el_66,'\n        Sauvegarder\n      ',(null as any));
    this._text_68 = this.renderer.createText(this._el_2,'\n\n            ',(null as any));
    this._text_69 = this.renderer.createText(this._el_0,'\n\n          ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'ngSubmit',this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_0,'submit',this.eventHandler(this._handle_submit_0_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_0,'reset',this.eventHandler(this._handle_reset_0_2.bind(this)));
    const subscription_0:any = this._FormGroupDirective_0_3.context.ngSubmit.subscribe(this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_13,'change',this.eventHandler(this._handle_change_13_0.bind(this)));
    var disposable_4:Function = this.renderer.listen(this._el_13,'blur',this.eventHandler(this._handle_blur_13_1.bind(this)));
    var disposable_5:Function = this.renderer.listen(this._el_20,'input',this.eventHandler(this._handle_input_20_0.bind(this)));
    var disposable_6:Function = this.renderer.listen(this._el_20,'blur',this.eventHandler(this._handle_blur_20_1.bind(this)));
    var disposable_7:Function = this.renderer.listen(this._el_28,'input',this.eventHandler(this._handle_input_28_0.bind(this)));
    var disposable_8:Function = this.renderer.listen(this._el_28,'blur',this.eventHandler(this._handle_blur_28_1.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._el_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._text_31,
      this._text_32,
      this._el_33,
      this._text_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._anchor_40,
      this._text_41,
      this._text_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._anchor_51,
      this._text_52,
      this._text_53,
      this._text_54,
      this._el_55,
      this._text_56,
      this._text_57,
      this._el_58,
      this._text_59,
      this._el_60,
      this._text_61,
      this._anchor_62,
      this._text_63,
      this._text_64,
      this._text_65,
      this._el_66,
      this._text_67,
      this._text_68,
      this._text_69
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6,
      disposable_7,
      disposable_8
    ]
    ,[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import36.CheckboxControlValueAccessor) && (13 === requestNodeIndex))) { return this._CheckboxControlValueAccessor_13_3.context; }
    if (((token === import37.NG_VALUE_ACCESSOR) && (13 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_13_4; }
    if (((token === import38.FormControlName) && (13 === requestNodeIndex))) { return this._FormControlName_13_5.context; }
    if (((token === import39.NgControl) && (13 === requestNodeIndex))) { return this._NgControl_13_6; }
    if (((token === import40.NgControlStatus) && (13 === requestNodeIndex))) { return this._NgControlStatus_13_7.context; }
    if (((token === import41.DefaultValueAccessor) && (20 === requestNodeIndex))) { return this._DefaultValueAccessor_20_3.context; }
    if (((token === import37.NG_VALUE_ACCESSOR) && (20 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_20_4; }
    if (((token === import38.FormControlName) && (20 === requestNodeIndex))) { return this._FormControlName_20_5.context; }
    if (((token === import39.NgControl) && (20 === requestNodeIndex))) { return this._NgControl_20_6; }
    if (((token === import40.NgControlStatus) && (20 === requestNodeIndex))) { return this._NgControlStatus_20_7.context; }
    if (((token === import41.DefaultValueAccessor) && (28 === requestNodeIndex))) { return this._DefaultValueAccessor_28_3.context; }
    if (((token === import37.NG_VALUE_ACCESSOR) && (28 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_28_4; }
    if (((token === import38.FormControlName) && (28 === requestNodeIndex))) { return this._FormControlName_28_5.context; }
    if (((token === import39.NgControl) && (28 === requestNodeIndex))) { return this._NgControl_28_6; }
    if (((token === import40.NgControlStatus) && (28 === requestNodeIndex))) { return this._NgControlStatus_28_7.context; }
    if (((token === import25.TemplateRef) && (40 === requestNodeIndex))) { return this._TemplateRef_40_5; }
    if (((token === import42.NgFor) && (40 === requestNodeIndex))) { return this._NgFor_40_6.context; }
    if (((token === import43.FormGroupName) && ((38 <= requestNodeIndex) && (requestNodeIndex <= 41)))) { return this._FormGroupName_38_3.context; }
    if (((token === import44.ControlContainer) && ((38 <= requestNodeIndex) && (requestNodeIndex <= 41)))) { return this._ControlContainer_38_4; }
    if (((token === import40.NgControlStatusGroup) && ((38 <= requestNodeIndex) && (requestNodeIndex <= 41)))) { return this._NgControlStatusGroup_38_5.context; }
    if (((token === import25.TemplateRef) && (51 === requestNodeIndex))) { return this._TemplateRef_51_5; }
    if (((token === import42.NgFor) && (51 === requestNodeIndex))) { return this._NgFor_51_6.context; }
    if (((token === import43.FormGroupName) && ((49 <= requestNodeIndex) && (requestNodeIndex <= 52)))) { return this._FormGroupName_49_3.context; }
    if (((token === import44.ControlContainer) && ((49 <= requestNodeIndex) && (requestNodeIndex <= 52)))) { return this._ControlContainer_49_4; }
    if (((token === import40.NgControlStatusGroup) && ((49 <= requestNodeIndex) && (requestNodeIndex <= 52)))) { return this._NgControlStatusGroup_49_5.context; }
    if (((token === import25.TemplateRef) && (62 === requestNodeIndex))) { return this._TemplateRef_62_5; }
    if (((token === import42.NgFor) && (62 === requestNodeIndex))) { return this._NgFor_62_6.context; }
    if (((token === import43.FormGroupName) && ((60 <= requestNodeIndex) && (requestNodeIndex <= 63)))) { return this._FormGroupName_60_3.context; }
    if (((token === import44.ControlContainer) && ((60 <= requestNodeIndex) && (requestNodeIndex <= 63)))) { return this._ControlContainer_60_4; }
    if (((token === import40.NgControlStatusGroup) && ((60 <= requestNodeIndex) && (requestNodeIndex <= 63)))) { return this._NgControlStatusGroup_60_5.context; }
    if (((token === import45.FormGroupDirective) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 69)))) { return this._FormGroupDirective_0_3.context; }
    if (((token === import44.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 69)))) { return this._ControlContainer_0_4; }
    if (((token === import40.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 69)))) { return this._NgControlStatusGroup_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parent.context.messageForm;
    this._FormGroupDirective_0_3.check_form(currVal_0_0_0,throwOnChange,false);
    this._FormGroupDirective_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._CheckboxControlValueAccessor_13_3.detectChangesInInputProps(this,this._el_13,throwOnChange);
    const currVal_13_1_0:any = 'active';
    this._FormControlName_13_5.check_name(currVal_13_1_0,throwOnChange,false);
    this._FormControlName_13_5.detectChangesInInputProps(this,this._el_13,throwOnChange);
    this._NgControlStatus_13_7.detectChangesInInputProps(this,this._el_13,throwOnChange);
    this._DefaultValueAccessor_20_3.detectChangesInInputProps(this,this._el_20,throwOnChange);
    const currVal_20_1_0:any = 'label';
    this._FormControlName_20_5.check_name(currVal_20_1_0,throwOnChange,false);
    this._FormControlName_20_5.detectChangesInInputProps(this,this._el_20,throwOnChange);
    this._NgControlStatus_20_7.detectChangesInInputProps(this,this._el_20,throwOnChange);
    this._DefaultValueAccessor_28_3.detectChangesInInputProps(this,this._el_28,throwOnChange);
    const currVal_28_1_0:any = 'url';
    this._FormControlName_28_5.check_name(currVal_28_1_0,throwOnChange,false);
    this._FormControlName_28_5.detectChangesInInputProps(this,this._el_28,throwOnChange);
    this._NgControlStatus_28_7.detectChangesInInputProps(this,this._el_28,throwOnChange);
    const currVal_38_0_0:any = 'title';
    this._FormGroupName_38_3.check_name(currVal_38_0_0,throwOnChange,false);
    this._FormGroupName_38_3.detectChangesInInputProps(this,this._el_38,throwOnChange);
    this._NgControlStatusGroup_38_5.detectChangesInInputProps(this,this._el_38,throwOnChange);
    const currVal_40_0_0:any = ((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_40_6.check_ngForOf(currVal_40_0_0,throwOnChange,false);
    this._NgFor_40_6.detectChangesInInputProps(this,this._anchor_40,throwOnChange);
    const currVal_49_0_0:any = 'subtitle';
    this._FormGroupName_49_3.check_name(currVal_49_0_0,throwOnChange,false);
    this._FormGroupName_49_3.detectChangesInInputProps(this,this._el_49,throwOnChange);
    this._NgControlStatusGroup_49_5.detectChangesInInputProps(this,this._el_49,throwOnChange);
    const currVal_51_0_0:any = ((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_51_6.check_ngForOf(currVal_51_0_0,throwOnChange,false);
    this._NgFor_51_6.detectChangesInInputProps(this,this._anchor_51,throwOnChange);
    const currVal_60_0_0:any = 'content';
    this._FormGroupName_60_3.check_name(currVal_60_0_0,throwOnChange,false);
    this._FormGroupName_60_3.detectChangesInInputProps(this,this._el_60,throwOnChange);
    this._NgControlStatusGroup_60_5.detectChangesInInputProps(this,this._el_60,throwOnChange);
    const currVal_62_0_0:any = ((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_62_6.check_ngForOf(currVal_62_0_0,throwOnChange,false);
    this._NgFor_62_6.detectChangesInInputProps(this,this._anchor_62,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._FormGroupDirective_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._CheckboxControlValueAccessor_13_3.detectChangesInHostProps(this,this._el_13,throwOnChange);
    this._FormControlName_13_5.detectChangesInHostProps(this,this._el_13,throwOnChange);
    this._NgControlStatus_13_7.detectChangesInHostProps(this,this._el_13,throwOnChange);
    this._DefaultValueAccessor_20_3.detectChangesInHostProps(this,this._el_20,throwOnChange);
    this._FormControlName_20_5.detectChangesInHostProps(this,this._el_20,throwOnChange);
    this._NgControlStatus_20_7.detectChangesInHostProps(this,this._el_20,throwOnChange);
    this._DefaultValueAccessor_28_3.detectChangesInHostProps(this,this._el_28,throwOnChange);
    this._FormControlName_28_5.detectChangesInHostProps(this,this._el_28,throwOnChange);
    this._NgControlStatus_28_7.detectChangesInHostProps(this,this._el_28,throwOnChange);
    this._FormGroupName_38_3.detectChangesInHostProps(this,this._el_38,throwOnChange);
    this._NgControlStatusGroup_38_5.detectChangesInHostProps(this,this._el_38,throwOnChange);
    this._FormGroupName_49_3.detectChangesInHostProps(this,this._el_49,throwOnChange);
    this._NgControlStatusGroup_49_5.detectChangesInHostProps(this,this._el_49,throwOnChange);
    this._FormGroupName_60_3.detectChangesInHostProps(this,this._el_60,throwOnChange);
    this._NgControlStatusGroup_60_5.detectChangesInHostProps(this,this._el_60,throwOnChange);
    const currVal_106:boolean = !this.parent.context.messageForm.valid;
    if (import5.checkBinding(throwOnChange,this._expr_106,currVal_106)) {
      this.renderer.setElementProperty(this._el_66,'disabled',currVal_106);
      this._expr_106 = currVal_106;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_13_5.context.ngOnDestroy();
    this._FormControlName_20_5.context.ngOnDestroy();
    this._FormControlName_28_5.context.ngOnDestroy();
  }
  private _handle_ngSubmit_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.context.onSubmit()) !== false);
    return (true && pd_0_0);
  }
  private _handle_submit_0_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this._FormGroupDirective_0_3.context.onSubmit($event)) !== false);
    return (true && pd_0_0);
  }
  private _handle_reset_0_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this._FormGroupDirective_0_3.context.onReset()) !== false);
    return (true && pd_0_0);
  }
  private _handle_change_13_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_13_0:any = ((<any>this._CheckboxControlValueAccessor_13_3.context.onChange($event.target.checked)) !== false);
    return (true && pd_13_0);
  }
  private _handle_blur_13_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_13_0:any = ((<any>this._CheckboxControlValueAccessor_13_3.context.onTouched()) !== false);
    return (true && pd_13_0);
  }
  private _handle_input_20_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_20_0:any = ((<any>this._DefaultValueAccessor_20_3.context.onChange($event.target.value)) !== false);
    return (true && pd_20_0);
  }
  private _handle_blur_20_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_20_0:any = ((<any>this._DefaultValueAccessor_20_3.context.onTouched()) !== false);
    return (true && pd_20_0);
  }
  private _handle_input_28_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_28_0:any = ((<any>this._DefaultValueAccessor_28_3.context.onChange($event.target.value)) !== false);
    return (true && pd_28_0);
  }
  private _handle_blur_28_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_28_0:any = ((<any>this._DefaultValueAccessor_28_3.context.onTouched()) !== false);
    return (true && pd_28_0);
  }
}
function viewFactory_ContentMessageEditComponent4(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentMessageEditComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_ContentMessageEditComponent5 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _DefaultValueAccessor_5_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_5_4:any[];
  _FormControlName_5_5:import31.Wrapper_FormControlName;
  _NgControl_5_6:any;
  _NgControlStatus_5_7:import29.Wrapper_NgControlStatus;
  _text_6:any;
  /*private*/ _expr_12:any;
  _pipe_uppercase_1_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentMessageEditComponent5,renderType_ContentMessageEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_12 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','col-md-6 input-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','input-group-addon max-width-20'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_0,'input',new import5.InlineArray4(4,'class','form-control','type','text'),(null as any));
    this._DefaultValueAccessor_5_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_5));
    this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
    this._FormControlName_5_5 = new import31.Wrapper_FormControlName((<_View_ContentMessageEditComponent4>this.parent)._ControlContainer_38_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_5_4);
    this._NgControl_5_6 = this._FormControlName_5_5.context;
    this._NgControlStatus_5_7 = new import29.Wrapper_NgControlStatus(this._NgControl_5_6);
    this._text_6 = this.renderer.createText(this._el_0,'\n                  ',(null as any));
    this._pipe_uppercase_1_0 = import5.pureProxy1((<_View_ContentMessageEditComponent0>this.parent.parent)._pipe_uppercase_1.transform.bind((<_View_ContentMessageEditComponent0>this.parent.parent)._pipe_uppercase_1));
    var disposable_0:Function = this.renderer.listen(this._el_5,'input',this.eventHandler(this._handle_input_5_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_5,'blur',this.eventHandler(this._handle_blur_5_1.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import41.DefaultValueAccessor) && (5 === requestNodeIndex))) { return this._DefaultValueAccessor_5_3.context; }
    if (((token === import37.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_5_4; }
    if (((token === import38.FormControlName) && (5 === requestNodeIndex))) { return this._FormControlName_5_5.context; }
    if (((token === import39.NgControl) && (5 === requestNodeIndex))) { return this._NgControl_5_6; }
    if (((token === import40.NgControlStatus) && (5 === requestNodeIndex))) { return this._NgControlStatus_5_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this._DefaultValueAccessor_5_3.detectChangesInInputProps(this,this._el_5,throwOnChange);
    const currVal_5_1_0:any = this.context.$implicit;
    this._FormControlName_5_5.check_name(currVal_5_1_0,throwOnChange,false);
    this._FormControlName_5_5.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_12:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_0,(<_View_ContentMessageEditComponent0>this.parent.parent)._pipe_uppercase_1.transform)(this.context.$implicit)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_12,currVal_12))) {
      this.renderer.setText(this._text_3,currVal_12);
      this._expr_12 = currVal_12;
    }
    this._DefaultValueAccessor_5_3.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._FormControlName_5_5.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_5_5.context.ngOnDestroy();
  }
  private _handle_input_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onChange($event.target.value)) !== false);
    return (true && pd_5_0);
  }
  private _handle_blur_5_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onTouched()) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentMessageEditComponent5(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentMessageEditComponent5(viewUtils,parentInjector,declarationEl);
}
class _View_ContentMessageEditComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _DefaultValueAccessor_5_3:import32.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_5_4:any[];
  _FormControlName_5_5:import31.Wrapper_FormControlName;
  _NgControl_5_6:any;
  _NgControlStatus_5_7:import29.Wrapper_NgControlStatus;
  _text_6:any;
  /*private*/ _expr_12:any;
  _pipe_uppercase_1_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentMessageEditComponent6,renderType_ContentMessageEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_12 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','col-md-6 input-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','input-group-addon max-width-20'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_0,'input',new import5.InlineArray4(4,'class','form-control','type','text'),(null as any));
    this._DefaultValueAccessor_5_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer,new import13.ElementRef(this._el_5));
    this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
    this._FormControlName_5_5 = new import31.Wrapper_FormControlName((<_View_ContentMessageEditComponent4>this.parent)._ControlContainer_49_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_5_4);
    this._NgControl_5_6 = this._FormControlName_5_5.context;
    this._NgControlStatus_5_7 = new import29.Wrapper_NgControlStatus(this._NgControl_5_6);
    this._text_6 = this.renderer.createText(this._el_0,'\n                  ',(null as any));
    this._pipe_uppercase_1_1 = import5.pureProxy1((<_View_ContentMessageEditComponent0>this.parent.parent)._pipe_uppercase_1.transform.bind((<_View_ContentMessageEditComponent0>this.parent.parent)._pipe_uppercase_1));
    var disposable_0:Function = this.renderer.listen(this._el_5,'input',this.eventHandler(this._handle_input_5_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_5,'blur',this.eventHandler(this._handle_blur_5_1.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import41.DefaultValueAccessor) && (5 === requestNodeIndex))) { return this._DefaultValueAccessor_5_3.context; }
    if (((token === import37.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_5_4; }
    if (((token === import38.FormControlName) && (5 === requestNodeIndex))) { return this._FormControlName_5_5.context; }
    if (((token === import39.NgControl) && (5 === requestNodeIndex))) { return this._NgControl_5_6; }
    if (((token === import40.NgControlStatus) && (5 === requestNodeIndex))) { return this._NgControlStatus_5_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this._DefaultValueAccessor_5_3.detectChangesInInputProps(this,this._el_5,throwOnChange);
    const currVal_5_1_0:any = this.context.$implicit;
    this._FormControlName_5_5.check_name(currVal_5_1_0,throwOnChange,false);
    this._FormControlName_5_5.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_12:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_1,(<_View_ContentMessageEditComponent0>this.parent.parent)._pipe_uppercase_1.transform)(this.context.$implicit)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_12,currVal_12))) {
      this.renderer.setText(this._text_3,currVal_12);
      this._expr_12 = currVal_12;
    }
    this._DefaultValueAccessor_5_3.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._FormControlName_5_5.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_5_5.context.ngOnDestroy();
  }
  private _handle_input_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onChange($event.target.value)) !== false);
    return (true && pd_5_0);
  }
  private _handle_blur_5_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onTouched()) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentMessageEditComponent6(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentMessageEditComponent6(viewUtils,parentInjector,declarationEl);
}
class _View_ContentMessageEditComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  /*private*/ _appEl_5:import3.AppElement;
  _HtmlEditorComponent_5_4:import46.Wrapper_HtmlEditorComponent;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_10:any;
  _pipe_uppercase_1_2:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentMessageEditComponent7,renderType_ContentMessageEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_10 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','form-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'small',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_0,'html-editor',new import5.InlineArray2(2,'height','3'),(null as any));
    this._appEl_5 = new import3.AppElement(5,0,this,this._el_5);
    var compView_5:any = import46.viewFactory_HtmlEditorComponent0(this.viewUtils,this.injector(5),this._appEl_5);
    this._HtmlEditorComponent_5_4 = new import46.Wrapper_HtmlEditorComponent();
    this._appEl_5.initComponent(this._HtmlEditorComponent_5_4.context,([] as any[]),compView_5);
    this._text_6 = this.renderer.createText((null as any),'\n                    ',(null as any));
    compView_5.create(this._HtmlEditorComponent_5_4.context,([] as any[]),(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                  ',(null as any));
    this._pipe_uppercase_1_2 = import5.pureProxy1((<_View_ContentMessageEditComponent0>this.parent.parent)._pipe_uppercase_1.transform.bind((<_View_ContentMessageEditComponent0>this.parent.parent)._pipe_uppercase_1));
    var disposable_0:Function = this.renderer.listen(this._el_5,'onEditorKeyup',this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
    const subscription_0:any = this._HtmlEditorComponent_5_4.context.onEditorKeyup.subscribe(this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ,[disposable_0],[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import47.HtmlEditorComponent) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._HtmlEditorComponent_5_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    const currVal_5_0_0:any = ('editor-content-' + this.context.$implicit);
    this._HtmlEditorComponent_5_4.check_elementId(currVal_5_0_0,throwOnChange,false);
    const currVal_5_0_1:any = (this.parent.parent.context.content? this.parent.parent.context.content.content[this.context.$implicit]: '');
    this._HtmlEditorComponent_5_4.check_initText(currVal_5_0_1,throwOnChange,false);
    const currVal_5_0_2:any = '3';
    this._HtmlEditorComponent_5_4.check_height(currVal_5_0_2,throwOnChange,false);
    this._HtmlEditorComponent_5_4.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_10:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_2,(<_View_ContentMessageEditComponent0>this.parent.parent)._pipe_uppercase_1.transform)(this.context.$implicit)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_10,currVal_10))) {
      this.renderer.setText(this._text_3,currVal_10);
      this._expr_10 = currVal_10;
    }
    this._HtmlEditorComponent_5_4.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._HtmlEditorComponent_5_4.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._HtmlEditorComponent_5_4.context.ngOnDestroy();
  }
  private _handle_onEditorKeyup_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this.parent.parent.context.keyupEditorHandlerFunction([
      'content',
      this.context.$implicit
    ]
    ,$event)) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentMessageEditComponent7(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentMessageEditComponent7(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-message-edit.component.ngfactory.ts